s<template>
  <div v-if="data.length!={}" id="brand2">
    <div class="lv2Text t">收藏的品牌</div>
    <div v-if="data.total>0">
      <el-row :gutter="40">
        <el-col :span="8" v-for="(item,index) in data.results" :key="index">
          <div class="item" @mouseover="hover(item.c_id)" v-on:mouseleave="leave">
            <div
              align="right"
              style="margin-bottom:-16px;position:relative;right:10px;top:5px;height:16px;"
            >
              <div v-if="hoverId==item.c_id">
                <span @click="cancel(item.id)">
                  <i class="fas fa-times"></i>
                </span>
              </div>
            </div>
            <div class="logo">
              <el-image
                lazy
                style="width: 270px; height: 130px"
                :src="serve +'/'+item.logo"
                fit="cover"
              ></el-image>
            </div>
            <div class="lv3Text name">
              <router-link :to="'/user/viewBrand?id='+item.id">{{item.name}}</router-link>
            </div>
          </div>
        </el-col>
      </el-row>
      <div align="center" class="pager">
        <el-pagination
        hide-on-single-page
          background
          layout="prev, pager, next"
          :total="data.total"
          :page-size="12"
          @current-change="pageChange"
        ></el-pagination>
      </div>
    </div>
    <div v-else class="empty lv4Text">
      <!-- <i class="fas fa-box-open fa-lg" style="margin-right:10px"></i>没有商品 -->
      <img style="margin : 0 auto" :src="serve + '/image/none/none_img4.jpg'" alt="">
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      //
      serve: this.$store.state.serve,
      mobile: this.$cookies.get("user"),
      token: this.$cookies.get("token"),
      page: 1,
      data: [],
      hoverId: 0
    };
  },
  created() {
    //
   
    this.$store.state.leftMenuIndex = 18;
    this.initData();
  },
  activated() {
    this.$store.state.user_location = "收藏的品牌";
  },
  methods: {
    cancel(i) {
      this.axios
        .get(this.serve + "/collect/cancel_collect_brand", {
          params: {
            mobile: this.mobile,
            token: this.token,
            brand_id: i
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.$message("已取消收藏");
            this.load();
          }
        });
    },
    leave() {
      this.hoverId = 0;
    },
    hover(i) {
      this.hoverId = i;
    },
    pageChange(v) {
      this.page = v;
      this.load();
    },
    load() {
      this.data = [];
      this.axios
        .get(this.serve +"/collect/collect_brand_list", {
          params: {
            mobile: this.mobile,
            token: this.token,
            page: this.page
          }
        })
        .then(res => {
          this.data = res.data.data;
        });
    },
    initData() {
      this.axios
        .get(this.serve +"/collect/collect_brand_list", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token"),
            page: 1
          }
        })
        .then(res => {
          this.data = res.data.data;
        });
    }
  }
};
</script>
<style lang="scss">
#brand2 {
  min-height: 600px;
  .empty {
    padding: 20px 0;
  }
  .fa-times {
    cursor: pointer;
  }
  .fa-times:hover {
    color: #e2211c;
  }
  background-color: #fff;
  padding: 20px;
  .t {
    font-size: 16px;
    margin-bottom: 20px;
  }
  .item {
    margin-bottom: 30px;
    border: 1px solid #ddd;
    padding: 10px;
  }
  .logo {
    margin-bottom: 10px;
  }
  .name {
    text-align: center;
  }
  .name:hover {
    text-decoration: underline;
  }
}
</style>